import { Component, OnInit, Inject, SecurityContext } from '@angular/core';
import { ViewGrievanceAttachmentComponent } from '../../users/consultant/consultant-open-grievances/view-grievance-attachment/view-grievance-attachment.component';
import { Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import * as myGlobals from '../../../app.component';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-view-grievance-user',
  templateUrl: './view-grievance-user.component.html',
  styleUrls: ['./view-grievance-user.component.scss']
})
export class ViewGrievanceUserComponent implements OnInit {
  replyData: any;
  attachmentFlag: boolean = false;
  grievanceAttchPath: any;
  grievanceImg: any;
  replyAttachmentFlag: any;
  grievanceReplyAttchPath: any;
  grievanceReplyImg: any;
  replyFlag: boolean = false;
  extension:any;
  replyExtension:any;

  testUrl = 'test-slaapi.aicte-india.org/files/Grievances/GrievanceAttachment_GRIVR8U2222I5_1635228737.pdf'
  public baseUrl = myGlobals.baseFileUrl;

  constructor(
    public dialog: MatDialog,
    protected sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.replyData = data['data'];
  }

  ngOnInit(): void {
    if (this.replyData['status'] == 'Closed') {
      this.replyFlag = true;
    }
    this.setAttchments();
  }

  photoURL(urll) {
    return this.sanitizer.sanitize(SecurityContext.URL ,urll);
  }

  setAttchments() {
    // For user's attachment
    if (this.replyData['attachment']) {
      this.attachmentFlag = true;
      this.grievanceAttchPath = this.replyData['attachment'];
      this.extension = this.replyData['attachment'].split('.').pop();
      this.grievanceImg =
        this.baseUrl + '/Grievances/' + this.grievanceAttchPath;
    } else {
      this.attachmentFlag = false;
    }

    // Reply attachment
    if (this.replyData['reply_attachment']) {
      this.replyAttachmentFlag = true;
      this.grievanceReplyAttchPath = this.replyData['reply_attachment'];
      this.replyExtension = this.replyData['reply_attachment'].split('.').pop();
      this.grievanceReplyImg =
        this.baseUrl + '/Grievances_reply/' + this.grievanceReplyAttchPath;
    } else {
      this.replyAttachmentFlag = false;
    }
  }

  viewImg(data) {
    data = '/Grievances/' + data;
    const dialogRef = this.dialog.open(ViewGrievanceAttachmentComponent, {
      data: { data }
    });
    dialogRef.afterClosed().subscribe(() => {});
  }

  viewReplyImg(data) {
    data = '/Grievances_reply/' + data;
    const dialogRef = this.dialog.open(ViewGrievanceAttachmentComponent, {
      data: { data }
    });
    dialogRef.afterClosed().subscribe(() => {});
  }
}
